import { combineSX } from '@/utils/combineSX';
import { Box, SxProps } from '@mui/material';
import { keyframes } from '@mui/system';

interface Props {
	percent: number;
	frameSx?: SxProps;
	barSx?: SxProps;
}

const loadingAnimation = keyframes`
	0% {
		transform: translateX(-100%);
	}
	100% {
		transform: translateX(400%);
	}
`;

export const DpFanDialogProgressBar = ({ percent, frameSx, barSx }: Props) => {
	const isLoading = percent === -1;

	return (
		<Box
			sx={combineSX([
				{
					backgroundColor: '#F3F1F6',
					height: '9px',
					width: '100%',
					overflow: 'hidden',
				},
				frameSx,
			])}
		>
			<Box
				sx={combineSX([
					{
						backgroundColor: 'primary.main',
						height: '9px',
						width: isLoading ? '25%' : `${percent}%`,
					},
					isLoading && {
						animation: `${loadingAnimation} 1.5s infinite linear`,
					},
					barSx,
				])}
			/>
		</Box>
	);
};
